module.exports = __webpack_public_path__ + "static/media/Huntail_gaussian2.bb136808.png";